module.exports = __webpack_public_path__ + "img/arrow-up-wide-short.475a6f98.svg";